// extracted by mini-css-extract-plugin
export default {"head":"List_head__pIg4F","headMain":"List_headMain__CSCtB","pad0":"List_pad0__UWPQ2","id":"List_id__dND2R","btntbl":"List_btntbl__tyAUq","btns":"List_btns__oBnn6"};